import { useSetState, useDeepCompareEffect } from 'ahooks'
import { Form } from 'antd-mobile'
import dayjs from 'dayjs'
import React from 'react'

import NewEditForm from '@/components/NewEditForm'
import { useCommonForm } from '@/hooks'
import { isNumber, checkMonthsDifference } from '@/utils/index'

import HPopup from '../../HYBVant/HPopup'
import './index.less'

const HealthCertificate: React.FC<any> = ({ visible, onCancel, modalData }) => {
  const {
    staff_Id,
    runSaveSocialSecurityAdjust,
    runDeleteSocialSecurityAdjust,
    saveSocialSecurityAdjustLoading,
    deleteSocialSecurityAdjustLoading,
    status,
    editItem
  } = modalData
  const [formIt] = Form.useForm()
  const [{ randomForm }, setState] = useSetState<any>({
    randomForm: null
  })
  console.log('status----editItem', status, editItem)
  const onFinish = (fieldValues: any) => {
    if (saveSocialSecurityAdjustLoading || deleteSocialSecurityAdjustLoading) return
    const social_security_effective_month = fieldValues?.social_security_effective_month
      ? dayjs(fieldValues?.social_security_effective_month).format('YYYY-MM')
      : null
    const provident_fund_effective_month = fieldValues?.provident_fund_effective_month
      ? dayjs(fieldValues?.provident_fund_effective_month).format('YYYY-MM')
      : null
    const values_info = [
      {
        ...editItem,
        ...fieldValues,
        social_security_effective_month,
        provident_fund_effective_month,
        employee_id: staff_Id || null
      }
    ]
    runSaveSocialSecurityAdjust(values_info)
  }

  useDeepCompareEffect(() => {
    const setFieldValues = (bool: boolean) => {
      const rowInfo = {
        ...editItem
      }
      formIt.setFieldsValue(rowInfo)

      setState({ randomForm: Math.random() })
    }
    setFieldValues(status === 'Edit')
  }, [status, editItem])
  const deleteInfo = () => {
    if (status === 'Edit') {
      const fields = editItem
      const id = fields?.id
      const ids = id ? [id] : null
      runDeleteSocialSecurityAdjust(ids)
    }
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }
  const vars = {
    is_disabled: false
  }
  const { option, optionStatus } = useCommonForm({
    code: status === 'Edit' ? 'social_security_records' : 'social_security_change_pay',
    vars: vars,
    immediate: true
  })
  console.log('optionStatus', optionStatus)
  return (
    <HPopup
      title={status === 'Edit' ? '编辑调整记录' : '调整'}
      hasOk={false}
      className='lg'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      {optionStatus === 'DONE' && (
        <div className='income-tax-declaration-popup'>
          {editItem?.type && (
            <div className='income-tax-declaration-popup-title'>{editItem?.type}</div>
          )}
          <NewEditForm
            formInst={formIt}
            formInfo={option?.formInfo ?? []}
            onFinish={onFinish}
            randomForm={randomForm}
            formButtons={getFormButtons(status === 'Edit')}
          />
        </div>
      )}
    </HPopup>
  )
}

export default HealthCertificate
